import React from "react";
import TrackVisibility from "react-on-screen";
import Sectiontitle from "../components/Sectiontitle";
import Layout from "../components/Layout";
import Progress from "../components/Progress";
import ResumeItem from "../components/ResumeItem";
import { useLanguage } from '../context/LanguageContext';

function Resumes() {
  const { d, lang } = useLanguage();
  const { skills, experience } = d;

  return (
    <Layout>
      <div className="mi-skills-area mi-section mi-padding-top">
        <div className="container">
          <Sectiontitle title={d.titles.skills} />
          <div className="mi-skills">
            <div className="row mt-30-reverse">
              {skills && skills.map(skill => (
                <TrackVisibility once className="col-lg-6 mt-30" key={skill.title}>
                  <Progress title={skill.title} percentage={skill.value} />
                </TrackVisibility>
              ))}
            </div>
          </div>
        </div>
      </div>

      {experience && (
        <div className="mi-resume-area mi-section mi-padding-top mi-padding-bottom">
          <div className="container">
            <Sectiontitle title={lang === 'es' ? 'Educación y Experiencia' : 'Education & Experience'} />
            <div className="row">
              {/* Educación va PRIMERO siempre en 1 sola columna */}
              {experience.educationExperience && experience.educationExperience.length > 0 && (
                <div className="col-12">
                  <div className="mi-smalltitle">
                    <span className="mi-smalltitle-icon">
                      <i className="lni lni-graduation"></i>
                    </span>
                    <h4>{lang === 'es' ? 'Educación' : 'Educational Qualifications'}</h4>
                  </div>
                  <div className="mi-resume-wrapper">
                    {experience.educationExperience.map(item => (
                      <ResumeItem key={item.id} resumeData={item} />
                    ))}
                  </div>
                </div>
              )}

              {/* Experiencia Laboral va DESPUÉS en 1 sola columna */}
              {experience.workingExperience && experience.workingExperience.length > 0 && (
                <div className="col-12">
                  <div className="mi-smalltitle">
                    <span className="mi-smalltitle-icon">
                      <i className="lni lni-briefcase"></i>
                    </span>
                    <h4>{lang === 'es' ? 'Experiencia Laboral' : 'Working Experience'}</h4>
                  </div>
                  <div className="mi-resume-wrapper">
                    {experience.workingExperience.map(item => (
                      <ResumeItem key={item.id} resumeData={item} />
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}

export default Resumes;
